import { useTranslation } from 'react-i18next';
// import InspectionStats from './components/InspectionStats';

import classNames from 'classnames';
import { useState } from 'react';
import WeeklyView from './components/WeeklyView';
import MonthlyView from './components/MonthlyView';
import AllView from './components/AllView';

// const inspectionStats = {
//   programmedInspections: 72,
//   totalProgrammedInspections: 85,
//   scheduledEstablishments: 38,
//   totalScheduledEstablishments: 45,
//   monitoredProducts: 1180,
//   totalProductsToBeMonitored: 1250,
//   fieldHours: 108,
//   totalFieldHours: 120,
// };

const MyInspections = () => {
  const { t } = useTranslation(['inspector']);

  const [selectedTab, setSelectedTab] = useState<number>(0);

  const tabItems: {
    key: number;
    label: string;
    children: JSX.Element;
  }[] = [    
    {
      key: 1,
      label: t('weeklyView'),
      children: <WeeklyView />,
    },
    {
      key: 2,
      label: t('monthlyView'),
      children: <MonthlyView />,
    },
    {
      key: 3,
      label: t('allView'),
      children: <AllView />,
    },
    /* {
      key: 4,
      label: t('reports'),
      children: (
        <div className="my-10 h-[40vh] text-2xl text-gray-400">{t('reportsComingSoon')}...</div>
      ),
    }, */
  ];

  return (
    <div className="w-full">
      {/* <InspectionStats
        scheduledEstablishments={inspectionStats.scheduledEstablishments}
        programmedInspections={inspectionStats.programmedInspections}
        totalProgrammedInspections={inspectionStats.totalProgrammedInspections}
        totalScheduledEstablishments={inspectionStats.totalScheduledEstablishments}
        monitoredProducts={inspectionStats.monitoredProducts}
        totalProductsToBeMonitored={inspectionStats.totalProductsToBeMonitored}
        fieldHours={inspectionStats.fieldHours}
        totalFieldHours={inspectionStats.totalFieldHours}
      /> */}

      <section className="mb-6 mt-16 grid w-full grid-cols-1 rounded-lg bg-card-bg-color p-2 md:w-fit md:grid-cols-3">
        {tabItems.map((item, index: number) => (
          <span
            className={classNames(
              'cursor-pointer px-3 py-2 text-center transition-colors duration-300 ease-in-out',
              { 'rounded-md bg-white text-primary': selectedTab === index }
            )}
            onClick={() => setSelectedTab(index)}
          >
            {item.label}
          </span>
        ))}
      </section>

      {tabItems[selectedTab].children}
    </div>
  );
};

export default MyInspections;
